<template>
  <div class="hero is-info is-fullheight">
    <div class="hero-body">
      <div class="container has-text-centered">
        <h1 class="title">Rikuso</h1>
        <div class="columns">
          <div class="column is-4 is-offset-4">
            <div v-if="isLoading">
              <progress
                class="progress is-small is-primary"
                max="100"
              ></progress>
              <div>{{ loadingMessage }}</div>
            </div>
            <button
              v-if="!isLoading"
              class="button is-info is-inverted is-outlined"
              @click="auth"
            >
              Sign in with Google Account
            </button>
            <div class="mt-4 has-text-danger">{{ errorMessage }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.progress.is-small {
  height: 0.1rem;
}
</style>
<script>
import session from '@/repositories/session';
export default {
  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
    loadingMessage() {
      return this.$store.state.loadingMessage;
    },
    errorMessage() {
      return this.$store.state.errorMessage;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    auth() {
      session.login();
    },
    async init() {
      this.$store.commit('isLoading', true);

      this.$store.commit('setLoadingMessage', 'Logging in...');
      const user = await this.$store.dispatch('checkAuth').catch((err) => {
        this.$store.commit('setErrorMessage', err);
      });

      if (user) {
        
        // 1. get async old orders first for display list items of the tabs ORDERS and BOOKING
        setTimeout(async() => {
          this.$store.commit('setLoadingMessage', 'Loading Assets...');
          await this.$store.dispatch('loadAssets');
          await this.$store.dispatch('fetchOrdersAndBookingItems');
        }, 1);

        // 2. get async new assets and orders then update all to old orders of step 2
        setTimeout(async() => {
          this.$store.commit('setLoadingMessage', 'Loading Items...');
            await this.$store.dispatch('fetchOrdersAndBookingItems');
            this.$store.commit('isLoading', false);
            if (this.$route.query.redirect) {
              this.$router.push({ path: this.$route.query.redirect });
            } else {
              this.$router.push({ name: 'orders' });
            }
        }, 1000);
      } else {
        this.$store.commit('isLoading', false);
      }
    },
  },
};
</script>
